"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const msal_react_1 = require("@azure/msal-react");
const react_router_dom_1 = require("react-router-dom");
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const AccountMenu_1 = __importDefault(require("@/components/AccountMenu"));
const Logo_1 = __importDefault(require("@/components/Logo"));
const style_1 = require("./style");
function HeaderView({ userEmail, tabsOptions, currentTab, onChangeTab, accountMenuOptions, }) {
    return (react_1.default.createElement(style_1.NavWrapper, null,
        react_1.default.createElement(style_1.StyledLink, { to: "/" },
            react_1.default.createElement(Logo_1.default, { style: { height: "32px", width: "107px", alignSelf: "center" } }),
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1" },
                react_1.default.createElement("strong", null, "Intelligent Feedstock Flow | Admin"))),
        react_1.default.createElement(style_1.Nav, null,
            react_1.default.createElement(Tabs_1.default, { indicatorColor: "primary", value: currentTab, onChange: onChangeTab }, tabsOptions.map((option) => {
                return (react_1.default.createElement(style_1.StyledLinkTab, { component: react_router_dom_1.Link, label: option.label, to: option.to, key: option.label }));
            }))),
        react_1.default.createElement(msal_react_1.AuthenticatedTemplate, null,
            react_1.default.createElement(style_1.AccountMenuWrapper, null,
                react_1.default.createElement(AccountMenu_1.default, { label: userEmail, options: accountMenuOptions })))));
}
exports.default = HeaderView;
